import { toInteger } from "lodash";
import {
  parseIncompletePhoneNumber,
  formatIncompletePhoneNumber,
} from "libphonenumber-js";

export const parseStringToInteger = (
  value: string | null | undefined
): number | undefined => {
  const onlyNums = value?.replace(/\D/g, "");
  if (!onlyNums) {
    return undefined;
  }

  return toInteger(onlyNums);
};

// Only works with inputs with type="number"
// this is because the decimal separator will be removed from this parsing method if the type is not number
export const parseStringToDecimal = (
  value: string | null | undefined,
  toFixed?: number
): number | undefined => {
  if (!value) return;

  const parsedFloat = parseFloat(value);
  if (isNaN(parsedFloat)) return;

  if (typeof toFixed === "number") {
    return parseFloat(parsedFloat.toFixed(toFixed));
  }

  return parsedFloat;
};

// only works with inputs with type="number"
export const parseStringToValidPercentage = (
  value: string | null | undefined,
  toFixed?: number
): number | undefined => {
  const parsedFloat = parseStringToDecimal(value, toFixed);
  if (!parsedFloat) return;
  if (parsedFloat > 100) return 100;
  if (parsedFloat < -100) return -100;
  return parsedFloat;
};

// Includes delimiters for readability
export const formatNumberToLocaleString = (value?: number | null): string =>
  value?.toLocaleString() ?? "";

export const formatNumberToYearString = (value?: number) =>
  value?.toLocaleString(navigator.language, {
    useGrouping: false,
  }) ?? "";

export function handlePhoneNumberInputChange(
  event: React.ChangeEvent<HTMLInputElement>,
  currentValue: string | number,
  onChange: (value: string) => void
) {
  const eventValue = event.currentTarget.value;
  let newVal = parseIncompletePhoneNumber(eventValue);
  const parsedCurrentValue = parseIncompletePhoneNumber(
    currentValue.toString()
  );

  // change max length of input depending on if the country code is included
  const maxLength = newVal[0] === "1" ? 12 : 11;

  if (newVal.length >= maxLength) {
    return;
  }
  // below is the same way the creator of the libphonenumber-js package handled input edge cases
  // https://github.com/catamphetamine/react-phone-number-input/blob/master/source/InputBasic.js#L34
  // By default, if a value is something like `"(123)"`
  // then Backspace would only erase the rightmost brace
  // becoming something like `"(123"`
  // which would then be parsed to `"123"`
  // which would then be formatted back to `"(123)"`
  // and so a user wouldn't be able to erase the phone number.
  // Working around this issue with this simple hack.
  if (newVal === parsedCurrentValue) {
    const newValueFormatted = formatIncompletePhoneNumber(newVal, "US");
    if (newValueFormatted.indexOf(eventValue) === 0) {
      newVal = newVal.slice(0, -1);
    }
  }

  onChange(newVal);
}
